import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useExamplePreview } from 'hooks/useExamplePreview';

import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { INonCurrentAssetsTableProps } from './types';
import { ProjectedBalanceFieldTable } from '../../../../components/ProjectedBalanceFieldTable';
import { assetsPrefix, FIRST_COLUMN_WIDTH } from '../../../../utils/form';
import {
  ASSETS_FORM_NAMES,
  NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES,
  useGetAssetsTotalRows,
  useGetNonCurrentAssetsVariants,
} from '../../utils/form';

export const NonCurrentAssetsTable: FC<INonCurrentAssetsTableProps> = ({ disabled = false }) => {
  const period = useWatch({ name: GLOBAL_PERIOD_NAME });
  const { isExamplePage} = useExamplePreview()

  const { getValues } = useFormContext();
  const nonCurrentAssetsVariants = useGetNonCurrentAssetsVariants(isExamplePage);
  const { nonCurrentAssetsTotalRowTitle } = useGetAssetsTotalRows();

  const tableName = concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE);
  const totalName = concatWithDot(assetsPrefix, ASSETS_FORM_NAMES.NON_CURRENT_ASSETS_TABLE_TOTAL);

  const totalValues = getValues(totalName);
  const fields = getValues([
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.INTANGIBLE_ASSETS),
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.PROPERTY_PLANT_AND_EQUIPMENT),
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.RIGHT_OF_USE_ASSETS),
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.GOODWILL),
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.LONG_TERM_INVESTMENTS),
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.DEFERRED_TAX_ASSETS),
    concatWithDot(tableName, NON_CURRENT_ASSETS_TABLE_TOTAL_NAMES.OTHER_NON_CURRENT_ASSETS),
  ]);

  return (
    <ProjectedBalanceFieldTable
      disabled={disabled}
      firstColumnWidth={FIRST_COLUMN_WIDTH}
      name={tableName}
      rows={fields}
      rowTitles={nonCurrentAssetsVariants}
      totalRowTitle={nonCurrentAssetsTotalRowTitle}
      totalName={totalName}
      period={period}
      totalValues={totalValues}
    />
  );
};
